var map = {
	"./data": 32419,
	"./data.js": 32419,
	"./data_en": 79206,
	"./data_en.js": 79206,
	"./news/company/10001.md": 80082,
	"./news/product/20001.md": 23454,
	"./news/product/20002.md": 74268,
	"./news/profession/30001.md": 23600,
	"./product/diagnosis.md": 54641,
	"./product/eLearn.md": 41670,
	"./product/ota.md": 61328,
	"./product/vehicle.md": 84024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54213;